import { forwardRef } from 'react';

import { Select, SelectProps } from '.';

interface Program {
  programCode?: string;
  programID: number;
  programName: string;
}

interface ProgramSelectProps extends Omit<
  SelectProps,
  'options' | 'value' | 'onChange'
> {
  onChange?: (value?: Array<number>) => void;
  programs: Array<Program>;
  value?: Array<number> | number | null;
}

export const getProgramIDs = (selectedValue: unknown): Array<number> => {
  const selectedValues = Array.isArray(selectedValue)
    ? selectedValue
    : [selectedValue];

  return selectedValues.reduce<Array<number>>((accumulator, selected) => {
    if (selected == null || selected === '') {
      return accumulator;
    }

    const programID = Number(selected);
    if (!Number.isNaN(programID)) {
      accumulator.push(programID);
    }
    return accumulator;
  }, []);
};

const ProgramSelect = forwardRef(
  (
    { onChange, programs, value, ...props }: ProgramSelectProps,
    ref?: React.Ref<HTMLInputElement>,
  ) => (
    <Select
      {...props}
      multiple={true}
      onChange={(selectedValue) => {
        onChange?.(getProgramIDs(selectedValue));
      }}
      options={[
        ...programs.map(({ programCode, programID, programName }) => ({
          label: `${programName}${programCode ? ` - ${programCode}` : ''}`,
          value: programID,
        })),
      ]}
      ref={ref}
      renderLabel="Programs"
      value={Array.isArray(value) ? value : value == null ? [] : [value]}
    />
  ),
);

export default ProgramSelect;
